import { Component, OnInit } from '@angular/core';
import { NetworkEpg } from 'src/app/shared/model/network-epg-model/network-epg';
import { NetworkEpgService } from 'src/app/shared/service/network-epg.service';
import { NewsService } from 'src/app/shared/service/epg-news.service';
import { EpgNews } from 'src/app/shared/model/news-model/news';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
    selector: 'app-spotlight',
    templateUrl: './spotlight.component.html',
    styleUrls: ['./spotlight.component.scss']
})
export class SpotlightComponent implements OnInit{

    showSpotlightView: boolean = false;
    imageLoaded: { [key: number]: boolean } = {};
    networkLogoUrl: string = "";
    logoUrl: string;
    networkSelected: boolean = false;
    networkNotSelected: boolean = true;
    networkEpg: NetworkEpg[] = [];
    networkEpgActual: NetworkEpg;
    date = new FormControl(moment());
    private readonly MIN_DATE_IN_DAYS = new Date().getDate() - 365;
    private readonly MAX_DATE_IN_DAYS = new Date().getDate() + 365;
    minDate = new Date();
    maxDate = new Date();
    datePickerStartDate: string = moment().format('YYYY-MM-DD');
    datePickerChanged: string = "";
    //Carousel
    epgNewsCarousel: EpgNews[] = [];
    defaultLogoUrl: string = environment.bucketUrlImagesNewsLogo;
    numSlides: number = 0;
    isPaused: boolean = false;

    modifiedFileParams: string;
    createdFileParams: string;
    infoMessage: string;
    errorMessage: string;

    constructor
        (

            private newsService: NewsService,
            private networkEpgService: NetworkEpgService,
        ) {
            this.logoUrl = environment.bucketUrlImagesNetworksLogo;
    }

    ngOnInit(): void {
        this.minDate.setDate(this.MIN_DATE_IN_DAYS);
        this.maxDate.setDate(this.MAX_DATE_IN_DAYS);
        this.networkEpgService.getAllNetwork().subscribe(networks => {
            this.networkEpg = networks;
        })
        this.newsService.findByNetworkDateAndImage().subscribe((data) => {
            this.epgNewsCarousel = data;
            this.numSlides = this.epgNewsCarousel.length;
            this.showSpotlightView = this.numSlides > 0;
            document.documentElement.style.setProperty('--contentvalue', this.numSlides.toString());
        });
    }

    getFactor() {
        return this.numSlides;
    }

    pauseAnimation() {
        if (this.epgNewsCarousel.length >= 1) {
            this.isPaused = true;
            document.querySelector('.slide-track').classList.add('paused');
        }
    }

    resumeAnimation() {
        if (this.epgNewsCarousel.length >= 1) {
            this.isPaused = false;
            document.querySelector('.slide-track').classList.remove('paused');
        }
    }

    getFactshet() {
        this.networkEpgService.downloadFile(environment.bucketUrlFeeds + this.networkEpgActual.factSheet)
    }

    getLogo() {
        this.networkEpgService.downloadFile(environment.bucketUrlFeeds + this.networkEpgActual.pressKit)
    }

    getCarouselLoop(): any[] {
        const base = this.epgNewsCarousel;
        if (base.length === 1) {
            return Array(10).fill(base[0]);
        }
        return [...base, ...base, ...base];
    }

    getNetwork(networkId: number): string {
        const network = this.networkEpg.find(net => net.id == networkId);
          return network?.code;
    }

    getNetworkLogo(networkId: number): string {

        const network = this.networkEpg.find(net => net.id == networkId);

        this.networkLogoUrl = this.logoUrl + network?.code.toLowerCase() + ".png";
        return this.networkLogoUrl;
    }


onImageLoad(networkId: number): void {
  this.imageLoaded[networkId] = true;
}

onImageError(networkId: number): void {
  this.imageLoaded[networkId] = false;
}
}
